(function () {
    var remainingChars = 255;
    var inputLength = 0;

    var elements = {
        input: document.querySelector('.char-limit'),
        limitDisplay: document.querySelector('.char-limit-value')
    };

    var events = function () {
        elements.input.onkeyup = updateChars;
    };

    var updateChars = function (e) {
        var newInputLength = e.target.value.length;

        if (newInputLength > inputLength) {
            remainingChars -= (newInputLength - inputLength);
        }
        else if (newInputLength < inputLength) {
            remainingChars += (inputLength - newInputLength);
        }
        inputLength = newInputLength;
        elements.limitDisplay.textContent = remainingChars;
    };

    var init = function () {
        if (elements.input) {
            inputLength = elements.input.value.length;
            remainingChars -= inputLength;

            events();
        }

        if (elements.limitDisplay) {
            elements.limitDisplay.textContent = remainingChars;
        }
    };

    init();
}());
